import classNames from 'classnames';
import React from 'react';
import { EuProject } from '../../../types/eu-project';
import { SectionTilesTypesProps } from '../../../utils/SectionProps';
import SectionHeader, { SectionHeaderTag } from '../partials/SectionHeader';
import Image from '../../elements/Image';

interface EuProjectsProps extends SectionTilesTypesProps {
  className?: string;
  content: EuProject[];
}

const defaultProps: EuProjectsProps = {
  topOuterDivider: false,
  bottomOuterDivider: false,
  topDivider: false,
  bottomDivider: false,
  hasBgColor: false,
  invertColor: false,
  pushLeft: false,
  content: [],
};

const EuProjects: React.FC<EuProjectsProps> = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  content,
  ...props
}) => {
  const outerClasses = classNames(
    'eu-projects section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider',
  );

  return (
    <section id="eu-projects-section" {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <div className="center-content mb-32">
            <Image src={content?.[0].image.publicURL} alt="EU Projects" height={0} width={360} />
          </div>
          <h4 className="center-content">PROJECT</h4>

          <SectionHeader
            tag={SectionHeaderTag.H1}
            title={content?.[0].header}
            className="center-content pb-32"
          ></SectionHeader>

          <div dangerouslySetInnerHTML={{ __html: content?.[0].contentEn }}></div>
        </div>
      </div>
    </section>
  );
};

EuProjects.defaultProps = defaultProps;

export default EuProjects;
